require('./globalPositionAccounts.scss');
const PropTypes = require('prop-types');
// @ vendors
const React = require('react');
const { withRouter } = require('react-router-dom');
// @ helpers
const { formatText } = require('core/i18n').i18n;
const { getLastNChars } = require('utilities/stringHelper');
const { formatAmountObject } = require('utilities/currencyHelper');
const classnames = require('classnames');
const includes = require('lodash/collection/includes');
const some = require('lodash/collection/some');
// @ constants
const { EURO_TEXT, PLURAL_CHARACTER } = require('constants/index');
// @ components
const GlobalPositionFinancialCard = require('components/globalPosition/globalPositionFinancialCard/globalPositionFinancialCard');

class GlobalPositionAccounts extends React.Component {

    constructor(props) {
        super(props);
        this.handleBoxClick = this.handleBoxClick.bind(this);
    }

    getAccounts(accountsIds) {
        const { immAccountsById, isBalanceDrawn } = this.props;

        //(nicolas.olmos): In order to not iterate over the array 2 times, we use reduce to filter and map it in only one iteration
        return accountsIds.reduce((accum, accountId) => {
            const immAccount = immAccountsById.get(accountId);

            if (immAccount.getIn(['filters', 'valid'])) {
                const amount = isBalanceDrawn
                    ? immAccount.getIn(['balanceDrawn', 'amount'])
                    : immAccount.getIn(['balance', 'amount'])

                const row = {
                    title: immAccount.get('alias'),
                    titleSmall: getLastNChars(immAccount.get('iban'), 4),
                    amount,
                    currency: immAccount.getIn(['balance', 'currency']),
                    hasWarnings: immAccount.get('indicadorAVISOA'),
                    warningCode: immAccount.get('indicadorINDACCI'),
                    warningLink: `/myprofile/accounts/${accountId}/warnings`,
                    link: `/myprofile/accounts/${accountId}/movements`
                };

                if (immAccount.get('hasPregrantedCredit')) {
                    const pregrantedCreditsLabel = formatText('myGlobalPosition-pregrantedCredits');
                    const formattedAmount = formatAmountObject(immAccount.getIn(['balances', 'pregrantedCredit']));
                    row.secondLine = `${pregrantedCreditsLabel} ${formattedAmount.amount}${formattedAmount.currencySymbol}`;
                }

                accum.push(row);
            }

            return accum;
        }, []);
    }

    getCurrencyDetail(balance) {
        // @hardcoded: this should be a global helper function
        // (we are doing something similar than here in other components)
        const convertToEuro = amountObject => amountObject.amount;

        return [{
            currency: EURO_TEXT,
            amount: balance.map(entry => convertToEuro(entry)).reduce((prev, next) => prev + next),
            legend: formatText('myGlobalPosition-balance')
        }]
    }

    handleBoxClick(evt) {
        const linkToCardsView = '/myprofile/accounts';
        const classListWithoutRedirect = [
            'ok-collapsing-toggler'
        ];
        if (!some(evt.target.parentElement.classList, (el) => includes(classListWithoutRedirect, el))) {
            this.props.history.push(linkToCardsView);
        }
    }
    render() {
        const {immAccountsByOrder, balance, excludedItems, expanded, id } = this.props;
        const pluralPostfix = excludedItems !== 1 ? PLURAL_CHARACTER : '';
        const subtitle = excludedItems > 0 ? formatText('myGlobalPosition-excludedAccounts', [excludedItems, pluralPostfix, pluralPostfix]) : '';
        const hasExcludedItems = excludedItems > 0;
        const currencyDetails = this.getCurrencyDetail(balance.toJS());
        const content = immAccountsByOrder.toJS();
        const accounts = this.getAccounts(content);
        const accountsInformationTooltipText = formatText('myGlobalPosition-accountsBalanceTooltipText');
        const financialCardClass = classnames({
            'global-position-accounts-section__subsection--is-clickable': !expanded
        });

        return (
            <div onClick={!expanded ? this.handleBoxClick : undefined} className={financialCardClass}>
                <GlobalPositionFinancialCard
                    id={id}
                    icon="rebrand-accounts"
                    amount={accounts.length}
                    cards={accounts}
                    currencyDetails={currencyDetails}
                    hasExcludedItems={hasExcludedItems}
                    showMoreText={formatText('myGlobalPosition-accountsShowMore')}
                    showMoreLink="/myprofile/accounts"
                    title={formatText('myGlobalPosition-accounts')}
                    subtitle={subtitle}
                    expanded={expanded}
                    allItemsExcluded={excludedItems === immAccountsByOrder.size}
                    emptyStateMessage={formatText('myGlobalPosition-allAccountsExcluded')}
                    informationTooltip={accountsInformationTooltipText}
                    titleLink="/myprofile/accounts"
                    keepSign={true}
                />
            </div>
        );
    }
}


GlobalPositionAccounts.propTypes = {
    history: PropTypes.object.isRequired,
    immAccountsByOrder: PropTypes.object.isRequired,
    immAccountsById: PropTypes.object.isRequired,
    balance: PropTypes.object.isRequired,
    excludedItems: PropTypes.number,
    expanded: PropTypes.bool,
    onClick: PropTypes.func,
    id: PropTypes.string
};

module.exports = withRouter(GlobalPositionAccounts);
